import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import LocationMap from '../components/LocationMap';
import { useSchoolInfo } from '../hooks/useSchoolInfo';

export default function ContactPage() {
  const schoolInfo = useSchoolInfo();
  return (
    <div className="bg-white pb-20">
      
      {/* Header Banner following container line */}
      <section className="bg-[#eef4e6] border-b border-[#d9e5d4] py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D2923] tracking-tight font-serif-heading">
              Vi er altid klar til at hjælpe
            </h1>
            <p className="text-base sm:text-lg text-[#5A6961] leading-relaxed">
              Uanset om du vil booke et besøg, skrive dit barn op eller har praktiske spørgsmål, er du altid velkommen til at kontakte os.
            </p>
          </div>
        </div>
      </section>

      {/* Main Grid following container line */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          
          {/* Left Column: Contact Cards */}
          <div className="lg:col-span-5 space-y-6">
            
            <div className="space-y-6">
              <h2 className="text-2xl font-bold text-[#1D2923] font-serif-heading">
                {schoolInfo.name}
              </h2>

              <div className="space-y-5 text-sm text-[#3E4E45]">
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-location-dot text-[#264A35] text-base w-5 mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <div className="font-bold text-[#1D2923]">Adresse</div>
                    <div>{schoolInfo.address}</div>
                    <div>{schoolInfo.city}</div>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-phone text-[#264A35] text-base w-5 mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <div className="font-bold text-[#1D2923]">Telefon</div>
                    <a
                      href={`tel:${schoolInfo.phoneRaw}`}
                      className="text-[#264A35] hover:text-black font-semibold whitespace-nowrap transition-colors"
                    >
                      {schoolInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-envelope text-[#264A35] text-base w-5 mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <div className="font-bold text-[#1D2923]">E-mail</div>
                    <a
                      href={`mailto:${schoolInfo.email}`}
                      className="text-[#264A35] hover:text-black font-semibold whitespace-nowrap transition-colors"
                    >
                      {schoolInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-file-invoice text-[#264A35] text-base w-5 mt-0.5 shrink-0" aria-hidden="true" />
                  <div>
                    <div className="font-bold text-[#1D2923]">CVR-nummer</div>
                    <div className="font-mono text-xs">{schoolInfo.cvr}</div>
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-[#d9e5d4] text-xs text-[#5A6961]">
                <strong>Kontortider:</strong> Mandag – fredag kl. 07.45 – 15.00
              </div>
            </div>

          </div>

          {/* Right Column: Contact Form */}
          <div className="lg:col-span-7">
            <ContactForm formTitle="Send os en henvendelse" />
          </div>

        </div>
      </section>

      {/* Map Section */}
      <LocationMap showHeader={true} className="pt-16 pb-0" />

    </div>
  );
}
